import * as React from 'react'

import { ExternalLinkIcon } from 'lucide-react'
import { classList } from 'react-classlist-helper'

import { ISharedDelivery, ISharedSitePermit } from '~/client/graph'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ProjectsStore from '../../stores/domain/Projects.store'
import InitialState from '../../stores/InitialState'
import { NOOP } from '../../utils/noop'

import './SharedEntityActions.scss'

const MIN_PHONE_LENGTH = 5

export interface ISharedAction {
  type: SharedEntityActionTypes
  label: string
  icon: JSX.Element
  disabled?: boolean
}

export enum SharedEntityActionTypes {
  GO_TO_PROJECT = 'goToProject',
  GO_TO_TO_LOCATION = 'goToToLocation',
  GO_TO_FROM_LOCATION = 'goToFromLocation',
  CALL_ADMIN = 'callAdmin',
  MAIL_ADMIN = 'mailAdmin',
  GO_TO_SETTINGS = 'goToSettings',
}

interface ISharedEntityActionsProps<T> {
  entity: T
  projectId: string
  companyName: string
  onActionClick: (
    actionType: SharedEntityActionTypes,
    sharedEntity: T,
    e: React.MouseEvent,
  ) => void
  isMobile?: boolean
  projectsStore?: ProjectsStore
  state?: InitialState
  renderActions?: () => JSX.Element
  renderInfo?: () => JSX.Element
  projectName?: string
}

export const SharedEntityActions = <T,>({
  renderActions,
  renderInfo,
  projectName,
}: ISharedEntityActionsProps<T>) => {
  const renderHeader = (): JSX.Element => {
    return (
      <div className="shared-delivery-header row px10 py5 y-center">
        <ExternalLinkIcon size={16} className="tw:mx-2.5 tw:text-background" />
        <div className="col">
          <div className="text bold white large">
            {Localization.translator.sharedFrom}
            <span className="text bold white large underline ml5">
              {projectName}
            </span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="shared-delivery-actions col">
      {renderHeader()}
      {renderInfo && renderInfo()}
      {renderActions && renderActions()}
    </div>
  )
}

export const isPhoneValid = (phone: string): boolean => {
  return !!phone && phone.length > MIN_PHONE_LENGTH
}

export const renderActionItem = (
  action: ISharedAction,
  onActionClick: (
    actionType: SharedEntityActionTypes,
    sharedEntity: ISharedDelivery | ISharedSitePermit,
    e: React.MouseEvent,
  ) => void,
  entity: ISharedDelivery | ISharedSitePermit,
): JSX.Element => {
  const { type, label, icon, disabled } = action
  const handleClick = disabled ? NOOP : onActionClick.bind(null, type, entity)

  return (
    <div
      key={type}
      className={classList({
        'shared-action-item row y-center px10 py8 pointer': true,
        disabled,
      })}
      onClick={handleClick}
    >
      <div className="action-icon mr10 no-grow tw:flex">{icon}</div>
      <span className="text extra-large">{label}</span>
    </div>
  )
}
